import React from 'react';
import { URL } from 'utils/url-builder';
import { SectionPage } from 'components/ui/skeletons/section-page';
import { TagList } from './tag-list';
import { TagPage } from './tag-page';

export const TagsPage = () => {
  return <SectionPage sectionListUrl={URL.tagList()} listComponent={TagList} pageComponent={TagPage} />;
};
